<div *ngIf="service && formGroup">
    <app-loading [loading]="loading" text="Chargement en cours"></app-loading>
    <app-error-card [error]="findOneError" *ngIf="findOneError && !hideFindOneErrorMessage"></app-error-card>

    <ng-content select="[error]">
    </ng-content>

    <div class="text-right">
        <ng-content select="[buttons]"></ng-content>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </div>

    <div [style]="loading || findOneError ? 'display: none;' : ''">
        <form [formGroup]="formGroup">
                <ng-container *ngTemplateOutlet="template"></ng-container>
        </form>


        <app-error-card *ngIf="deleteService && hideDeleteErrorMessage === false"
                        [style]="(deleteService.deleteErrors$ | async) ? '' : 'display: none;'" [error]="deleteService.deleteErrors$ | async"></app-error-card>
         <app-success-card message="Enregistrement effectué"
                           *ngIf="(service.saveSuccess$ | async) && !hideSuccessMessage"></app-success-card>


        <div class="text-center">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </div>
    </div>
</div>

<ng-template #buttons>
    <div *ngIf="queryByIdLoading === false && loading === false && hideButtons === false">
        <div class="m-y-4">
            <app-loading *ngIf="(deleteByIdLoading)" [showText]="false"></app-loading>
            <app-loading *ngIf="(saveLoading && !hideSaveButton)" [showText]="false"></app-loading>

            <div *ngIf="saveLoading === false && deleteByIdLoading === false && loading === false">
                <app-button size="small" (click)="save()" *ngIf="hideSaveButton === false" [disabled]="!formGroup.valid" fill="solid"
                            iconName="check" [label]="saveButtonLabel"></app-button>
                <app-confirmation-button size="small" (confirm)="delete($event)" *ngIf="mustDisplayDeleteButton()"
                                         color="primary" fill="solid" iconName="trash"
                                         label="Supprimer"></app-confirmation-button>
                <ng-content select="[buttons]">
                </ng-content>
            </div>
        </div>
    </div>
</ng-template>
